export default __webpack_public_path__ + "static/media/ig1.f540e374.svg";